"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_noundersDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_nounsDAOTreasury",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
            {
                internalType: "contract INounsSeeder",
                name: "_seeder",
                type: "address",
            },
            {
                internalType: "contract IProxyRegistry",
                name: "_proxyRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "InvalidIndex",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DescriptorLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract INounsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "DescriptorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MaxRewardLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "maxRewardNoun",
                type: "uint256",
            },
        ],
        name: "MaxRewardNounUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MinterLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "NounBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                indexed: false,
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "NounCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "noundersDAO",
                type: "address",
            },
        ],
        name: "NoundersDAOUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "nounsDAOTreasury",
                type: "address",
            },
        ],
        name: "NounsDAOTreasuryUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "SeederLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract INounsSeeder",
                name: "seeder",
                type: "address",
            },
        ],
        name: "SeederUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DELEGATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                internalType: "uint96",
                name: "votes",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "descriptor",
        outputs: [
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCurrentVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPriorVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDescriptorLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMaxRewardLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMinterLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSeederLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMaxRewardNoun",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "maxRewardNoun",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "noundersDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsDAOTreasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyRegistry",
        outputs: [
            {
                internalType: "contract IProxyRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seeder",
        outputs: [
            {
                internalType: "contract INounsSeeder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "seeds",
        outputs: [
            {
                internalType: "uint48",
                name: "background",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "body",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "accessory",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "head",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "glasses",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newContractURIHash",
                type: "string",
            },
        ],
        name: "setContractURIHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
        ],
        name: "setDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxRewardNoun",
                type: "uint256",
            },
        ],
        name: "setMaxRewardNoun",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_noundersDAO",
                type: "address",
            },
        ],
        name: "setNoundersDAO",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_nounsDAOTreasury",
                type: "address",
            },
        ],
        name: "setNounsDAOTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsSeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        name: "setSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "votesToDelegate",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_noundersDAO, _nounsDAOTreasury, _minter, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.deploy(_noundersDAO, _nounsDAOTreasury, _minter, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    getDeployTransaction(_noundersDAO, _nounsDAOTreasury, _minter, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.getDeployTransaction(_noundersDAO, _nounsDAOTreasury, _minter, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsToken__factory = NounsToken__factory;
NounsToken__factory.bytecode = _bytecode;
NounsToken__factory.abi = _abi;
